import shadow from './shadow';

export default shadow;
